import { render, staticRenderFns } from "./annotate.vue?vue&type=template&id=1c35cb2c&scoped=true&"
import script from "./annotate.vue?vue&type=script&lang=js&"
export * from "./annotate.vue?vue&type=script&lang=js&"
import style0 from "./annotate.vue?vue&type=style&index=0&id=1c35cb2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c35cb2c",
  null
  
)

export default component.exports